const truncateString = (text, charactersLength) => {
  if (text.length > charactersLength) {
    return `${text.substring(0, charactersLength)}...`;
  }
  return text;
};

export default truncateString;
